import { useNavigate } from 'react-router-dom';

export const useNavigatePage = path => {
  const navigate = useNavigate();

  const handleNavigate = row => {
    navigate(`${path}?fileId=${row.fileId}`);
  };

  return {
    handleNavigate,
  };
};